import React, {useEffect} from 'react';
import { KoFormBuilder } from 'packages';
import styles from './curd.module.scss';

function Inventory({ form, product }) {


  useEffect(()=>{
    form?.resetFields();
  },[]);


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        key: 'name', label: 'SKU' , placeholder: 'Type product SKU here...', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'SKU is required'
          }
        ]
      },
     
      {
        key: 'name', label: 'Barcode' , placeholder: 'Product barcode', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Barcode is required'
          }
        ]
      },
      {
        key: 'name', label: 'Quantity', placeholder: 'Type Product quantity here...', colSpan: 2,
        rules: [
          {
            required: true,
            message: 'Quantity is required'
          }
        ]
      }
    ]
  };

  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
};

export default Inventory;